import React from 'react'
import { Box, Button } from '@mui/material'
import AddCurriculum from '../shared/AddCurriculum'
import DeleteIcon from '@mui/icons-material/Delete'

export function AddCurriculaForDemo({
  curriculaMap,
  addCurriculum,
  removeCurriculum,
}: {
  curriculaMap: Map<string, number>
  addCurriculum: (title: string, curriculum: number) => void
  removeCurriculum: (title: string) => void
}) {
  return (
    <Box m={2}>
      <p>Curricula: </p>
      {Array.from(curriculaMap.keys()).map((title) => (
        <li key={title}>
          {title}
          <Button
            onClick={() => removeCurriculum(title)}
            key={title}
            color="primary"
          >
            <DeleteIcon />
          </Button>
        </li>
      ))}
      <AddCurriculum addCurriculumOverride={addCurriculum} onAdded={() => {}} />
    </Box>
  )
}
